import { render, staticRenderFns } from "./ArticlesBulkActions.vue?vue&type=template&id=debdefb8&scoped=true&"
import script from "./ArticlesBulkActions.vue?vue&type=script&lang=js&"
export * from "./ArticlesBulkActions.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesBulkActions.vue?vue&type=style&index=0&id=debdefb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debdefb8",
  null
  
)

export default component.exports